<h2>Termine</h2>

<section class="calendar-actions">
  <div class="filter-bttn" (click)="openCalendar()">
    Kalender öffnen...
  </div>

  <div class="hover-bttn" (click)="openAddAppointmentModal()">
    <ion-icon name="fa-plus"></ion-icon>
  </div>

</section>

@if (appointmentsUpcoming?.length > 0) {
  <section id="upcoming-appointments">
    <h3>Bevorstehende Termine ({{appointmentsUpcoming.length}})</h3>
    @for (appointment of appointmentsUpcoming; track appointment) {
      <ticket-detail-appointment-item [appointment]="appointment" (appointemtChanged)="sortAppointments()" (appontmentDeleted)="onDelete($event)"></ticket-detail-appointment-item>
    }
  </section>
}

@if (appointmentsPast?.length > 0) {
  <section id="finished-appointments">
    <h3>Vergangene Termine ({{appointmentsPast.length}})</h3>
    @for (appointment of appointmentsPast; track appointment) {
      <ticket-detail-appointment-item [appointment]="appointment" [finished]="true" (appointemtChanged)="sortAppointments()" (appontmentDeleted)="onDelete($event)"></ticket-detail-appointment-item>
    }
  </section>
}

@if(appointmentsPast?.length == 0 && appointmentsUpcoming?.length == 0){
  <p class="no-content">Keine Termine vorhanden</p>
}